import styled from 'styled-components'

import Button from '.'

const ButtonMedium = styled(Button)`
  padding-top: unset;
  padding-bottom: unset;
  height: 56px;
`

export default ButtonMedium
